import { Authorization } from './Authorization'

export interface Role {
  id: string
  name: string
  description: string
  type: string
  authorizations: Authorization[]
  createdAt: Date
  updatedAt: Date
}

export interface RoleCreateUpdatePayload {
  name?: string
  description?: string
  permissions?: string[]
}

export enum RoleType {
  SIDECAR = 'sidecar',
  SEAT = 'seat',
}

export interface BaseRoleGroup {
  name: string
  roleIds: string[]
}

export interface RoleGroup extends BaseRoleGroup {
  description?: string
  type: RoleType
}
